import styled from "styled-components";
import { ANIMATION } from "../../../../utils/constants";

// The only skeleton-specific style left: InvestmentsSkeleton borrows layout shells
// from the real section components rather than re-deriving the page structure here.
export const SkeletonBox = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "32px"};
  background: var(--gradient-skeleton);
  background-size: 200% 100%;
  animation: loading 1.5s ${ANIMATION.easing.easeInOut} infinite;
  border-radius: 4px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
